import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, fmtDate } from "@/lib/api";
import { PageHeader, Empty } from "@/components/Bits";

export default function Suppression() {
  const [rows, setRows] = useState([]);
  const [value, setValue] = useState("");
  const [reason, setReason] = useState("");
  const load = () => api.get("/suppression").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/suppression", { value, reason }); setValue(""); setReason(""); toast.success("Suppressed"); load(); } catch (x) { toast.error(errMsg(x)); }
  };
  const remove = async (id) => { await api.delete(`/suppression/${id}`); load(); };
  return (
    <>
      <PageHeader eyebrow="Never contacted · never resurfaced" title="Suppression List" />
      <form onSubmit={add} className="kh-card flex flex-wrap gap-3 p-5" data-testid="suppression-form">
        <Input className="max-w-xs" placeholder="email@domain.com or domain.com" value={value} onChange={(e) => setValue(e.target.value)} data-testid="suppression-value-input" />
        <Input className="max-w-sm" placeholder="Reason (optional)" value={reason} onChange={(e) => setReason(e.target.value)} data-testid="suppression-reason-input" />
        <Button disabled={!value} data-testid="suppression-add-btn">Add to list</Button>
      </form>
      {rows.length === 0 ? <Empty testid="suppression-empty">No suppressed contacts.</Empty> : (
        <div className="kh-card overflow-hidden">
          <table className="w-full text-left text-sm" data-testid="suppression-table">
            <thead><tr className="border-b text-[11px] uppercase tracking-wider text-muted-foreground"><th className="px-5 py-3">Value</th><th className="px-5 py-3">Type</th><th className="px-5 py-3">Reason</th><th className="px-5 py-3">Added</th><th /></tr></thead>
            <tbody>{rows.map((r) => (
              <tr key={r.id} className="border-b last:border-0" data-testid={`suppression-row-${r.id}`}>
                <td className="px-5 py-3 font-mono">{r.value}</td><td className="px-5 py-3 capitalize text-muted-foreground">{r.type}</td>
                <td className="px-5 py-3 text-muted-foreground">{r.reason}{r.lead_name ? ` · ${r.lead_name}` : ""}</td>
                <td className="px-5 py-3 text-muted-foreground">{fmtDate(r.created_at)} · {r.created_by}</td>
                <td className="px-5 py-3 text-right"><button onClick={() => remove(r.id)} className="text-muted-foreground hover:text-red-700" data-testid={`suppression-remove-${r.id}`}><Trash2 className="h-4 w-4" /></button></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </>
  );
}
